import { message } from "antd";
import { useCallback, useState } from "react";
import { geCardsForProjectTable, fetchData } from '../../../../helpers/projectTableBySpaceHelper';
import { useColumnsProjectTable } from "../../../../hooks/columns/useColumnsProjectTable";

const useTableProjects = () => {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [cardData, setCardData] = useState({
        CONCLUIDO: 0,
        ACTIVO: 0,
        PAUSA: 0,
        CANCELADO: 0,
        progress: 0,
        acceptable: 0,
        attention: 0,
        extended: 0,
        overflow: 0,
        workedHours: 0,
        budgetHours: 0,
    });

    const [modalDeleteProyect, setModalDeleteProyect] = useState({
        active: false,
        clickupSpace: "",
        name: "",
        type: ""
    })


    const { columns, updateColumnsTable } = useColumnsProjectTable();

    const updateModalDelete = ({ active = false, clickupSpace = "", name = "", type = "" }) => {
        setModalDeleteProyect({ active, clickupSpace, name, type })
    }

    const updateCards = ({ filters, projectsFilter = [], auth }) => {
        const { isSuperAdmin = false, isAdmin = false } = auth
        const cardData = geCardsForProjectTable(projectsFilter);

        setCardData(cardData);
        updateColumnsTable({ filters, isAdmin: isSuperAdmin || isAdmin, actionDeleteProyect: updateModalDelete });
    };

    const updateProjects = useCallback(
        async (isOwn, year, auth) => {
            setIsLoading(true);
            try {
                const { spaces, cardData, peopleInCharge, peopleInChargeProject, leaders } = await fetchData(isOwn, year);
                const { name: userName, isSuperAdmin = false, isAdmin = false } = auth
                console.log(spaces);

                setCardData(cardData);
                setProjects(spaces.map((s) => ({ ...s, key: s.clickupSpace })));
                updateColumnsTable({ userName, people: { leaders, peopleInCharge, peopleInChargeProject }, isAdmin: isSuperAdmin || isAdmin, actionDeleteProyect: updateModalDelete });
            } catch (error) {
                message.error("Error al recuperar proyectos");
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return {
        updateProjects,
        updateCards,
        updateModalDelete,
        isLoading,
        projects,
        cardData,
        columns,
        modalDeleteProyect
    };
};

export default useTableProjects;
